// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__26jk0","requiredAsterisk":"Info_requiredAsterisk__wzS7z"};